import React, { useState } from 'react';
import { v4 } from 'uuid';
import { get } from 'lodash';
import Dialog from 'components/shared/Dialog';
import Typo from 'components/shared/Typo';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import UpdateButton from 'components/shared/UpdateButton';
import { formatDate } from '../../utils';
import SectorKPIsTable from '../SectorKPIsTable';
import { IconLoader } from 'common/IconLoader';
import styles from './SectorKPIsDialog.module.css';

function SectorKPIsDialog({ open, device, refreshing, onRefresh, onClose }) {
  const [titleId] = useState(() => v4());
  const info = get(device, 'rfPath.normal-op-info');
  const lastUpdated = get(device, '$metadata.rfPath.normal-op-info.$lastUpdated');

  return (
    <Dialog aria-labelledby={titleId} open={open} onClose={onClose}>
      <Dialog.Container maxWidth={1120} maxHeight={900}>
        <Dialog.Title className={styles.title}>
          <Typo id={titleId} as="h3" variant="heading4">
            Sector KPIs
          </Typo>
          <UpdateButton className={styles.refresh} updating={refreshing} onClick={onRefresh}>
            Refresh
          </UpdateButton>
          <div className={styles.deviceIdsContainer}>
            <div className={styles.deviceIdContainer}>
              <SvgAF img={IconLoader.icon_donor} />
              <span className={styles.deviceId}>{device?.donorId}</span>
            </div>
            <div className={styles.deviceIdContainer}>
              <SvgAF img={IconLoader.icon_service} />
              <span className={styles.deviceId}>{device?.id}</span>
            </div>
          </div>
        </Dialog.Title>
        <SectorKPIsTable info={info} />
        <Dialog.Actions>
          <Typo as="p" variant="body2">
            Last updated: {formatDate(lastUpdated)}
          </Typo>
        </Dialog.Actions>
        <Dialog.Close />
      </Dialog.Container>
    </Dialog>
  );
}

export default SectorKPIsDialog;
